import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icons-search-9e1ad",
  "use": "icons-search-9e1ad-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icons-search-9e1ad\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.417 0a7.42 7.42 0 0 1 7.416 7.417 7.4 7.4 0 0 1-1.67 4.685l2.783 2.784-1.06 1.06-2.784-2.783A7.415 7.415 0 1 1 7.417 0m0 1.5a5.917 5.917 0 1 0 .001 11.834A5.917 5.917 0 0 0 7.417 1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol